/* Studio Collection - product page calculator (SCalc namespace)
   Pricing tables: audited 1:1 against the live Zurich calculator. Do not change.
   Cart wiring mirrors product-zurich-calc.js (deposit -> /cart/add.js, full -> /apps/quote/studio-draft-order). */
(function(){
  'use strict';

  // ── Pricing tables (do not modify) ────────────────────────────────────────
  function tierDigital(q){if(q<10)return 0;if(q<30)return 1;if(q<50)return 2;if(q<100)return 3;if(q<150)return 4;return 5;}
  function tierPress(q){if(q<30)return -1;if(q<50)return 0;if(q<80)return 1;if(q<100)return 2;if(q<150)return 3;return 4;}
  function tierAcrylic(q){if(q<10)return -1;if(q<30)return 0;if(q<50)return 1;if(q<100)return 2;if(q<150)return 3;return 4;}
  function tierOTD(q){if(q<30)return 0;if(q<50)return 1;if(q<100)return 2;if(q<200)return 3;return 4;}
  const INV = {
    digital: { base: { '100x150':[11.00,10.00,8.50,7.50,7.00,5.50], '120x180':[12.00,11.50,9.50,8.00,7.50,6.00], '148x210':[12.50,12.00,10.00,8.50,8.00,6.50] },
      addons: { foilSingle: { '100x150':6.00, '120x180':6.50, '148x210':7.00 }, doubleSided:[2.50,2.50,2.50,2.00,2.00,2.00], duplexing:[7.00,5.75,5.00,4.80,4.60,3.50], cutToShape:[2.50,2.50,2.50,2.00,2.00,2.00] } },
    acrylic: { base: { '100x150':[21.50,17.50,17.00,16.50,13.80], '120x180':[25.30,20.50,20.00,19.50,17.50] }, guestNamesSetup: 195.00, mirror: 3.00 },
    letterpress: { base: { '100x150':[28.50,18.50,13.80,11.50,10.00], '120x180':[32.00,21.30,16.70,15.00,13.00], '148x210':[34.00,23.00,18.50,16.00,14.50] }, addons: { secondColour: 6.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } },
    hotfoil: { base: { '100x150':[32.00,27.50,22.00,19.00,15.50], '120x180':[35.00,29.30,23.50,21.70,17.50], '148x210':[37.00,31.90,29.90,25.80,21.80] }, addons: { digital: 1.50, letterpress: 8.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } },
    embossed: { base: { '100x150':[53.00,35.50,27.60,23.50,19.50], '120x180':[55.00,36.80,28.70,24.70,20.70], '148x210':[57.00,38.00,29.90,25.80,21.90] }, addons: { letterpress: 8.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } },
    folded: { base: { '120x180':[19.00,17.80,16.70,15.50,13.80], '148x210':[20.00,19.00,18.00,17.00,16.00] }, addons: { foilSingle: 10.00, foilDouble: 15.00 } },
    infoCards: { card1:[8.00,7.50,5.20,4.60,4.00], card2:[6.00,5.20,4.60,4.00,3.50], addons: { cutToShape:[2.50,2.50,2.00,2.00,2.00] } },
    accessories: { vellum:[7.00,6.00,5.00,4.50,4.00], band:[6.00,5.20,4.00,3.50,3.50], laserPocketSimple:[18.00,16.10,13.30,12.50,11.50], pocketFoilFront: 8.00, pocketFoilBoth: 13.00, paperClips: 0.70 },
    assembly: [150.00,200.00,250.00,250.00,300.00]
  };
  const ENVELOPES = { upgrade: { 'C6': 0.90, 'C5': 1.90 }, printing: 2.50, liner: 4.50, embossedStamp: 195.00, embossedStamping: 4.00, waxStampCustom: 195.00, waxAdhesive: 5.50, waxStick: 9.50 };
  const RIBBON = { satin:7, velvet:9, silk:12 };
  const ILLUST = 150;

  // Icons (Shopify CDN URLs)
  const ICON = {
    clips:   'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_-_Paper_Clips_1dccdb6c-a0f4-4710-9de5-4beda977f80e.webp?v=1757229114',
    ribbon:  'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_-_ribbon.png?v=1757172529',
    band:    'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_band.png?v=1757222137',
    vellum:  'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_wrap.png?v=1757222144',
    pockets: 'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_Custom_Pockets.webp?v=1766034384',
    liner:   'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_-_liners.webp?v=1757232086',
    emboss:  'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_envelope_embbosing_49f5f437-0ed3-483e-8651-392bd2d9679b.webp?v=1757233214',
    sticker: 'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_stickers.webp?v=1757232206',
    wax:     'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_wax.webp?v=1757232209',
    stamp:   'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_mystamps_design.webp?v=1757429703'
  };
  const STEPS = ['Quantity','Print & Finishes','Your Suite','Envelopes','Review'];
  const ROMAN = ['I','II','III','IV','V'];

  // Which checkbox keys belong to which "finishing" group. Used to reset
  // hidden state when the user switches print style/format/method so that
  // a tickbox set under digital can't silently re-apply later.
  // `guestNames` is intentionally NOT scoped to a single group - it is the
  // same offer in both digital-flat and folded, so it carries over.
  const FIN_GROUPS = {
    digital:     ['dsp','foilS','duplex'],
    letterpress: ['lp2pms','lpFoil'],
    hotfoil:     ['hfDigital','hfLp'],
    embossed:    ['emLp','emHf'],
    folded:      ['foldFoilS','foldFoilD'],
    acrylic:     ['acMirror','acNames']
  };
  const ALL_FIN_KEYS = Object.values(FIN_GROUPS).reduce((a,b)=>a.concat(b),[]);

  // ── State ────────────────────────────────────────────────────────────────
  const state = {
    step:1, pay:'deposit', qty:0, size:null, format:null, style:null, method:null,
    info:0, shape:0, pocketFoil:'digital', ribbon:'satin', seal:'sticker', waxType:'adhesive',
    checks:{}
  };

  // Config injected from section settings (read once on init)
  const cfg = { designBase:200, deposit:200, otdAmount:100, monogramAmount:50, depositVariantGid:'', fullVariantGid:'', otdVariantGid:'', designName:'Studio Collection', tier:'SC' };

  // ── Persistence (localStorage) ─────────────────────────────────────────────
  // Mirrors the main quote calculator: a returning visitor (same browser /
  // device) gets their selections back plus a "Welcome back" banner. No backend
  // needed - purely client-side, expires after 30 days.
  const SCALC_STORAGE_KEY = 'felicitations_studio_state';
  const SCALC_TTL_DAYS = 30;
  let scalcSaveTimer = null;
  function scalcSave(){
    clearTimeout(scalcSaveTimer);
    scalcSaveTimer = setTimeout(()=>{
      try { localStorage.setItem(SCALC_STORAGE_KEY, JSON.stringify({ ts: Date.now(), s: state })); } catch(e){}
    }, 400);
  }
  function scalcLoad(){
    try {
      const raw = localStorage.getItem(SCALC_STORAGE_KEY);
      if(!raw) return null;
      const obj = JSON.parse(raw);
      if((Date.now() - obj.ts) / 86400000 > SCALC_TTL_DAYS){ localStorage.removeItem(SCALC_STORAGE_KEY); return null; }
      return { data: obj.s, ts: obj.ts };
    } catch(e){ return null; }
  }
  function scalcHasMeaningful(){
    return !!(state.qty > 0 || state.style || state.size || state.format || state.info > 0 ||
              Object.keys(state.checks || {}).some(k => state.checks[k]));
  }
  function scalcStartOver(){
    try { localStorage.removeItem(SCALC_STORAGE_KEY); } catch(e){}
    location.href = location.pathname;
  }
  // Re-apply the saved selections to the DOM (called once on init, after the
  // tiles are built). We set classes/values directly rather than calling the
  // setters, because the setters clear dependent finishes as a side-effect.
  function scalcApplyRestoredUI(){
    const qi = $('qtyIn'); if(qi) qi.value = state.qty || '';
    document.querySelectorAll('[data-style]').forEach(b => b.classList.toggle('on', b.dataset.style === state.style));
    document.querySelectorAll('[data-method]').forEach(b => b.classList.toggle('on', b.dataset.method === state.method));
    document.querySelectorAll('[data-size]').forEach(b => b.classList.toggle('on', b.dataset.size === state.size));
    document.querySelectorAll('[data-format]').forEach(b => b.classList.toggle('on', b.dataset.format === state.format));
    Object.keys(state.checks || {}).forEach(k => {
      if(!state.checks[k]) return;
      const cb = document.querySelector('[data-c="' + k + '"]'); if(cb) cb.checked = true;
      const tile = document.querySelector('[data-tile="' + k + '"]'); if(tile){ tile.classList.add('on'); tile.setAttribute('aria-pressed','true'); }
    });
    const setSel = $('setSel'); if(setSel) setSel.value = state.info || 0;
    const shapeSel = $('shapeSel'); if(shapeSel) shapeSel.value = state.shape || 0;
    const addrSel = $('addrSel'); if(addrSel) addrSel.value = (state.checks && state.checks.envAddr) ? 1 : 0;
    document.querySelectorAll('[data-rb]').forEach(b => b.classList.toggle('on', b.dataset.rb === state.ribbon));
    document.querySelectorAll('[data-pf]').forEach(b => b.classList.toggle('on', b.dataset.pf === state.pocketFoil));
    document.querySelectorAll('[data-wt]').forEach(b => b.classList.toggle('on', b.dataset.wt === state.waxType));
    document.querySelectorAll('[data-seal]').forEach(b => { const on = b.dataset.seal === state.seal; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    const rt = $('ribbonType'); if(rt) rt.hidden = !(state.checks && state.checks.ribbon);
    const pf = $('pocketFoil'); if(pf) pf.hidden = !(state.checks && state.checks.pockets);
    const wt = $('waxType'); if(wt) wt.hidden = state.seal !== 'wax';
    try { updateSetShapeLabels(); } catch(e){}
  }
  function scalcShowWelcome(ts){
    const root = document.querySelector('.studio-calc');
    if(!root || document.getElementById('scalc-welcome')) return;
    let dateStr = '';
    try { dateStr = new Date(ts).toLocaleDateString('en-AU', { day:'numeric', month:'long' }); } catch(e){}
    const bar = document.createElement('div');
    bar.id = 'scalc-welcome';
    bar.style.cssText = 'display:flex;align-items:center;gap:1rem;justify-content:center;flex-wrap:wrap;background:#faf7f3;border-bottom:1px solid #ece4d9;padding:14px 18px;color:#2a2520;font-size:.95rem;line-height:1.4';
    bar.innerHTML = '<span>Welcome back. We restored your selections' + (dateStr ? ' from <strong>' + dateStr + '</strong>' : '') + '.</span>' +
      '<a href="#" class="scalc-welcome-reset" style="color:#7a1c2e;text-decoration:underline;cursor:pointer">Start Over</a>' +
      '<a href="#" class="scalc-welcome-x" aria-label="Dismiss" style="color:#9a9a9a;text-decoration:none;font-size:1.3rem;line-height:1;cursor:pointer">&times;</a>';
    root.parentNode.insertBefore(bar, root);
    bar.querySelector('.scalc-welcome-reset').addEventListener('click', e => { e.preventDefault(); scalcStartOver(); });
    bar.querySelector('.scalc-welcome-x').addEventListener('click', e => { e.preventDefault(); bar.remove(); });
  }

  // First render = initial page load. We DON'T want to auto-scroll to the
  // calc on landing; the customer should see product gallery, copy, etc. first.
  // Scroll only fires on subsequent step navigations.
  let firstRender = true;

  // ── Helpers ──────────────────────────────────────────────────────────────
  const $ = id => document.getElementById(id);
  const fmt = n => '$' + (Math.round(n*100)/100).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});
  const fmt0 = n => '$' + Math.round(n).toLocaleString('en-AU');
  let lastTotal = 0;

  function minQty(){
    if(state.style==='presswork') return 30;
    if(state.style==='acrylic') return 10;
    return 1;
  }
  function sizesFor(){
    if(state.format==='folded') return ['120x180','148x210'];
    if(state.style==='acrylic') return ['100x150','120x180'];
    return ['100x150','120x180','148x210'];
  }
  function baseUnit(q){
    if(!q) return 0;
    const size = state.size;
    if(!size) return 0;
    if(state.format==='folded'){ const t=tierOTD(q); const key=size==='148x210'?'148x210':'120x180'; return INV.folded.base[key][t]; }
    if(state.style==='digital'){ return INV.digital.base[size][tierDigital(q)]; }
    if(state.style==='acrylic'){ const ta=tierAcrylic(q); return ta<0?0:INV.acrylic.base[size][ta]; }
    if(state.style==='presswork' && state.method){ const tp=tierPress(q); return tp<0?0:INV[state.method].base[size][tp]; }
    return 0;
  }
  function sizeLabel(s){ return {'100x150':'Petite A6','120x180':'Standard 120×180','148x210':'Traditional A5'}[s] || s; }

  // The Design Fee due today becomes $300 when OTD design is selected ($200 base + $100 OTD).
  // Routed through draft order endpoint (which needs write_draft_orders scope).
  function effectiveDeposit(){ return cfg.deposit + (state.checks.otdDesign ? cfg.otdAmount : 0); }
  function updateDepositButton(){
    const depBtn = document.querySelector('[data-pay="deposit"]');
    if (!depBtn) return;
    const dep = effectiveDeposit();
    depBtn.firstChild.nodeValue = `Pay Design Fee · $${dep}`;
  }

  // ── Pricing line items ───────────────────────────────────────────────────
  function lines(){
    const s = state, out = [], q = s.qty, cc = s.checks;
    if(q>0) out.push(['Invitation design (base)', cfg.designBase, 1]);
    if(q<=0) return out;
    const t = tierDigital(q), tp = tierPress(q), ta = tierAcrylic(q), tA = tierOTD(q);
    const size = s.size;
    if(!size || (!s.style && s.format!=='folded')) return out;

    if(s.format==='folded'){
      out.push([`Folded invitation ${sizeLabel(size)} × ${q}`, baseUnit(q)*q, 2]);
      if(cc.foldFoilS) out.push(['Signature flat foil (one side)', INV.folded.addons.foilSingle*q, 2]);
      if(cc.foldFoilD) out.push(['Signature flat foil (both sides)', INV.folded.addons.foilDouble*q, 2]);
    } else if(s.style==='acrylic'){
      if(ta<0){ out.push(['Acrylic requires min 10', 0, 2, true]); }
      else {
        out.push([`Acrylic invitation ${sizeLabel(size)} × ${q}`, INV.acrylic.base[size][ta]*q, 2]);
        if(cc.acMirror) out.push(['Mirror acrylic upgrade', INV.acrylic.mirror*q, 2]);
        if(cc.acNames)  out.push(['Personalised guest names (one-off)', INV.acrylic.guestNamesSetup, 2]);
      }
    } else if(s.style==='digital'){
      const ad = INV.digital.addons;
      out.push([`Digital invitation ${sizeLabel(size)} × ${q}`, INV.digital.base[size][t]*q, 2]);
      if(cc.dsp)    out.push(['Double-sided print', ad.doubleSided[t]*q, 2]);
      if(cc.foilS)  out.push(['Signature flat foil (front)', ad.foilSingle[size]*q, 2]);
      if(cc.duplex) out.push(['Duplexing 600gsm', ad.duplexing[t]*q, 2]);
    } else if(s.style==='presswork' && tp>=0 && s.method){
      const pset = INV[s.method], L = {letterpress:'Letterpress', hotfoil:'Hot Foil', embossed:'Embossed'};
      out.push([`${L[s.method]} invitation ${sizeLabel(size)} × ${q}`, pset.base[size][tp]*q, 2]);
      if(s.method==='letterpress'){ if(cc.lp2pms) out.push(['Second colour (2 PMS)', pset.addons.secondColour*q, 2]); if(cc.lpFoil) out.push(['Add hot foil', pset.addons.hotFoil*q, 2]); }
      else if(s.method==='hotfoil'){ if(cc.hfDigital) out.push(['Add digital print', pset.addons.digital*q, 2]); if(cc.hfLp) out.push(['Add letterpress (1 PMS)', pset.addons.letterpress*q, 2]); }
      else if(s.method==='embossed'){ if(cc.emLp) out.push(['Add letterpress (1 PMS)', pset.addons.letterpress*q, 2]); if(cc.emHf) out.push(['Add hot foil', pset.addons.hotFoil*q, 2]); }
    }

    if(s.info>=1){
      // "Additional card" only when folded - folded suites have a single
      // companion card. Flat suites use "Info card" (+ "Info card 2" if two).
      const cardLabel = s.format === 'folded' ? 'Additional card' : 'Info card';
      out.push([`${cardLabel} × ${q}`, INV.infoCards.card1[tA]*q, 3]);
    }
    if(s.info>=2) out.push([`Info card 2 × ${q}`, INV.infoCards.card2[tA]*q, 3]);
    const shape = s.shape;
    const cutInvite = (shape===1 || shape===4);
    const cutInfo1 = (shape===2 || shape===3 || shape===4);
    const cutInfo2 = ((shape===3 || shape===4) && s.info===2);
    if(cutInvite){
      let cp;
      if(s.format==='folded' || s.style==='digital') cp = INV.digital.addons.cutToShape[t];
      else if(s.style==='presswork' && tp>=0 && INV[s.method]) cp = INV[s.method].addons.cutToShape[tp];
      else cp = 2.00;
      out.push(['Custom cut · invitation', cp*q, 3]);
    }
    if(cutInfo1 && s.info>=1) out.push(['Custom cut · card', INV.infoCards.addons.cutToShape[tA]*q, 3]);
    if(cutInfo2 && s.info>=2) out.push(['Custom cut · info card 2', INV.infoCards.addons.cutToShape[tA]*q, 3]);
    if(cc.illust) out.push(['Hand-drawn custom illustration', ILLUST, 3]);
    if(cc.monogram && cfg.monogramAmount > 0) out.push(['Custom monogram', cfg.monogramAmount, 3]);
    if(cc.vellum) out.push(['Vellum wrap', INV.accessories.vellum[tA]*q, 3]);
    if(cc.band)   out.push(['Belly band', INV.accessories.band[tA]*q, 3]);
    if(cc.pockets){
      out.push(['Custom pockets or sleeves', INV.accessories.laserPocketSimple[tA]*q, 3]);
      if(s.pocketFoil==='foil') out.push(['Pocket signature foil', INV.accessories.pocketFoilFront*q, 3]);
    }
    if(cc.clips) out.push(['Paper clips', INV.accessories.paperClips*q, 3]);
    if(cc.ribbon){ out.push(['Hand-tied ribbon · '+s.ribbon, (RIBBON[s.ribbon]||0)*q, 3]); }
    if(cc.envUp){ const k = size==='100x150'?'C6':'C5'; out.push([`Premium coloured envelope`, ENVELOPES.upgrade[k]*q, 4]); }
    if(cc.envAddr)  out.push(['Guest & return addressing', ENVELOPES.printing*q, 4]);
    if(cc.envLiner) out.push(['Envelope liner', ENVELOPES.liner*q, 4]);
    if(cc.envEmb){ out.push(['Envelope embossing (one-off stamp)', ENVELOPES.embossedStamp, 4]); out.push(['Envelope embossing (per piece)', ENVELOPES.embossedStamping*q, 4]); }
    if(s.seal==='wax'){
      out.push(['Custom wax stamp (one-off)', ENVELOPES.waxStampCustom, 4]);
      if(s.waxType==='adhesive') out.push(['Adhesive wax seals', ENVELOPES.waxAdhesive*q, 4]);
      else out.push([`Wax sticks (DIY, ~${Math.ceil(q/7)} sticks)`, ENVELOPES.waxStick*Math.ceil(q/7), 4]);
    }
    if(cc.assembly) out.push(['Suite assembly (one-off)', INV.assembly[tA], 4]);
    if(cc.otdDesign) out.push(['On-the-day stationery design (matching)', cfg.otdAmount, 5]);
    return out;
  }

  // ── Qty + chips ──────────────────────────────────────────────────────────
  function onQty(v){ state.qty = Math.max(0, Math.min(500, parseInt(v,10)||0)); afterQtyChange(); }
  function bump(d){
    const base = state.qty || (80-d);
    state.qty = Math.max(0, Math.min(500, base+d));
    $('qtyIn').value = state.qty || '';
    afterQtyChange();
  }
  function pick(q){ state.qty = q; $('qtyIn').value = q; afterQtyChange(); }
  function afterQtyChange(){
    // If user dropped qty below the selected style's minimum, unselect that style.
    if(state.style && state.qty>0 && state.qty<minQty()){
      state.style = null;
      state.method = null;
      document.querySelectorAll('[data-style], [data-method]').forEach(b=>b.classList.remove('on'));
      // Clear any finishing-touch checkboxes that belonged to the now-unselected style.
      clearFinChecks([]);
    }
    refreshReveal(); updateQtyUI(); recalc(); validate();
  }
  function updateQtyUI(){
    const m = $('qtyMath'), q = state.qty;
    document.querySelectorAll('.scalc-chip').forEach(c=>c.classList.toggle('on', +c.dataset.q===q));
    if(!q){ m.innerHTML = '<span style="color:#b3aca5">Print pricing is added once you choose your size, format and finishes.</span>'; return; }
    m.innerHTML = `<b>${q}</b> invitations &nbsp;·&nbsp; pricing shown once you choose your finishes.`;
  }

  // ── Reset finishing-group checkboxes when style/format/method changes ───
  // `keep` is an array of group keys (e.g. ['digital','folded']) whose
  // checkbox state we want to preserve. Everything else is cleared in
  // state AND in the DOM so the UI matches the model.
  function clearFinChecks(keep){
    const keepSet = new Set();
    (keep||[]).forEach(g => (FIN_GROUPS[g]||[]).forEach(k=>keepSet.add(k)));
    ALL_FIN_KEYS.forEach(k=>{
      if(keepSet.has(k)) return;
      if(state.checks[k]){
        state.checks[k] = false;
        const el = document.querySelector(`[data-c="${k}"]`);
        if(el && el.type==='checkbox') el.checked = false;
      }
    });
  }

  // ── Price labels ─────────────────────────────────────────────────────────
  function refreshPrices(){
    const q = state.qty||100, t = tierDigital(q), tA = tierOTD(q), size = state.size||'100x150', ad = INV.digital.addons;
    const set = (id,v)=>{ const e=$(id); if(e) e.textContent = v; };
    set('p-dsp','+'+fmt(ad.doubleSided[t])+'/ea');
    set('p-foilS','+'+fmt(ad.foilSingle[size])+'/ea');
    set('p-duplex','+'+fmt(ad.duplexing[t])+'/ea');
    set('p-lp2pms','+'+fmt(INV.letterpress.addons.secondColour)+'/ea');
    set('p-lpFoil','+'+fmt(INV.letterpress.addons.hotFoil)+'/ea');
    set('p-hfDigital','+'+fmt(INV.hotfoil.addons.digital)+'/ea');
    set('p-hfLp','+'+fmt(INV.hotfoil.addons.letterpress)+'/ea');
    set('p-emLp','+'+fmt(INV.embossed.addons.letterpress)+'/ea');
    set('p-emHf','+'+fmt(INV.embossed.addons.hotFoil)+'/ea');
    set('p-foldFoilS','+'+fmt(INV.folded.addons.foilSingle)+'/ea');
    set('p-foldFoilD','+'+fmt(INV.folded.addons.foilDouble)+'/ea');
    set('p-acMirror','+'+fmt(INV.acrylic.mirror)+'/ea');
    set('p-assembly','+'+fmt(INV.assembly[tA])+' one-off');
    const ek = size==='100x150'?'C6':'C5';
    set('p-envUp','+'+fmt(ENVELOPES.upgrade[ek])+'/ea');
    const envL = $('invEnvLabel'); if(envL) envL.textContent = '';
    setTilePrice('clips','+'+fmt(INV.accessories.paperClips)+'/ea');
    setTilePrice('ribbon','from +'+fmt(RIBBON.satin)+'/ea');
    setTilePrice('band','+'+fmt(INV.accessories.band[tA])+'/ea');
    setTilePrice('vellum','+'+fmt(INV.accessories.vellum[tA])+'/ea');
    setTilePrice('pockets','+'+fmt(INV.accessories.laserPocketSimple[tA])+'/ea');
    setTilePrice('liner','+'+fmt(ENVELOPES.liner)+'/ea');
    setTilePrice('emboss','$195 + '+fmt(ENVELOPES.embossedStamping)+'/ea');
  }
  function setTilePrice(key,v){ const e = document.querySelector(`[data-tileprice="${key}"]`); if(e) e.textContent = v; }

  // ── Reveal / disable logic for step 2 ────────────────────────────────────
  function refreshReveal(){
    const folded = state.format==='folded';
    const q = state.qty;

    $('sizeGroup').hidden = !state.style;
    // Format row visible whenever the user has any style selected EXCEPT acrylic.
    $('formatGroup').hidden = !state.style || state.style==='acrylic';
    $('methodGroup').hidden = !(state.style==='presswork' && !folded);
    $('keepsakeGroup').hidden = !state.style;

    // Style buttons: always visible. Disable presswork / acrylic when qty below their min.
    // Digital is always available. Folded format forces digital style.
    document.querySelectorAll('[data-style]').forEach(b=>{
      const s = b.dataset.style;
      let disabled = false;
      if(folded){
        disabled = (s !== 'digital');
      } else if(q > 0){
        if(s === 'presswork' && q < 30) disabled = true;
        if(s === 'acrylic'   && q < 10) disabled = true;
      }
      b.disabled = disabled;
      b.classList.toggle('on', folded ? (s==='digital') : (state.style===s && !disabled));
    });

    // Luxury Presswork can't be produced folded - grey out the Folded option
    // (and drop it if somehow selected) whenever presswork is the chosen style.
    document.querySelectorAll('[data-format]').forEach(b=>{
      const disable = b.dataset.format==='folded' && state.style==='presswork';
      b.disabled = disable;
      if(disable) b.classList.remove('on');
    });

    // Style hint: tell the user which options unlock at higher quantities.
    const sh = $('printStyleHint');
    if(sh){
      const base = 'Fine flat print for speed. Luxury presswork for exquisite, textured results. Acrylic for a modern statement.';
      if(q===0) sh.innerHTML = base;
      else if(q<10) sh.innerHTML = base + '<br><em>Add more invitations to unlock Acrylic (from 10) and Luxury Presswork (from 30).</em>';
      else if(q<30) sh.innerHTML = base + '<br><em>Add more invitations to unlock Luxury Presswork (from 30).</em>';
      else sh.innerHTML = base;
    }

    // Finishing-touch groups: show only the one matching the current selection.
    $('finDigital').hidden = !(!folded && state.style==='digital');
    $('finLp').hidden      = !(!folded && state.style==='presswork' && state.method==='letterpress');
    $('finHf').hidden      = !(!folded && state.style==='presswork' && state.method==='hotfoil');
    $('finEm').hidden      = !(!folded && state.style==='presswork' && state.method==='embossed');
    $('finAcrylic').hidden = !(!folded && state.style==='acrylic');
    $('finFolded').hidden  = !folded;

    // Size buttons: filter by what the current style allows.
    const allowed = sizesFor();
    document.querySelectorAll('[data-size]').forEach(b=>{ b.style.display = allowed.includes(b.dataset.size) ? '' : 'none'; });
    if(state.size && !allowed.includes(state.size)){
      state.size = null;
      document.querySelectorAll('[data-size]').forEach(b=>b.classList.remove('on'));
    }

    $('formatHint').textContent = folded
      ? 'A folded invitation with its own foil options. Available in Standard and Traditional sizes.'
      : 'A single flat card, or a folded invitation with more room inside.';
    updateSetShapeLabels();
  }

  // ── Recalc + bottom bar + review ─────────────────────────────────────────
  // ── Design fee (scope-tiered, charged once via the shared cart helper) ──────
  function designTierKey(){ return cfg.tier==='TT' ? 'TT' : 'SC'; }
  function designScopeKey(){ return state.checks.otdDesign ? 'full' : 'inv'; }
  function priceTable(){ return (window.FelDesign && window.FelDesign.PRICE) || {SC:{std:100,inv:200,full:300},TT:{std:150,inv:300,full:500}}; }
  function designFeeAmt(){ return priceTable()[designTierKey()][designScopeKey()]; }
  // Production balance = everything except the design fee (exclude design base step 1 + OTD upsell step 5).
  function printTotal(){ return lines().reduce(function(a,l){ return a + ((l[2]!==1 && l[2]!==5) ? l[1] : 0); }, 0); }

  function recalc(){
    refreshPrices();
    const ls = lines();
    const print = printTotal(), fee = designFeeAmt(), total = print + fee, last = state.step===5;
    const amt = $('barAmt');
    if(last){
      $('barLbl').textContent = 'Design Fee due today';
      amt.textContent = fmt0(fee);
      $('barSub').textContent = '';
    } else {
      $('barLbl').textContent = (state.qty>0) ? `Total so far · ${state.qty} invitations` : 'Total so far';
      amt.textContent = fmt0(total);
      $('barSub').textContent = (fee > 0) ? `Design Fee due today: ${fmt0(fee)}` : '';
    }
    const nb = $('nextBtn'); if(nb) nb.style.display = '';
    // Step 1 uses the inline Continue; on review the bar shows the Design Fee due today + the pay CTA.
    const bar = document.querySelector('.studio-calc-bar'); if(bar) bar.style.display = (state.step===1) ? 'none' : '';
    const barTot = document.querySelector('.studio-calc-bar .bar-total'); if(barTot) barTot.style.visibility = 'visible';
    if(total !== lastTotal){ amt.classList.remove('pulse'); void amt.offsetWidth; amt.classList.add('pulse'); lastTotal = total; }
    if(last) renderReview();
    scalcSave();
  }

  function renderReview(){
    const r = $('rev'); if(!r) return; r.innerHTML = '';
    const mk = (tag,cls,html)=>{ const e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; };
    if(!state.qty || (!state.style && state.format!=='folded')){ r.innerHTML = '<div class="rev-l"><span class="rl">Make your selections to see your suite.</span></div>'; return; }
    const ls = lines(), print = printTotal(), fee = designFeeAmt(), P = priceTable();
    const tier = designTierKey(), scope = designScopeKey();
    const tierLabel = tier==='TT' ? 'Tailored Touch' : 'Studio Collection';
    const scopeShort = scope==='full' ? 'Full set' : 'Invitations';

    const tot = mk('div','dc-sum');
    const row = (l,v,cls)=> mk('div','dc-sum-row'+(cls?' '+cls:''), '<span class="dc-sum-l">'+l+'</span><span class="dc-sum-v">'+v+'</span>');
    tot.appendChild(row('Estimated Production Balance', fmt(print)));
    const coverLbl = {inv:'Invitations (Save the Dates included)', full:'Full suite'}[scope] || '';
    tot.appendChild(row('Design Fee · '+tierLabel+(coverLbl?' · '+coverLbl:''), fmt(fee)));
    tot.appendChild(mk('hr','dc-sum-hr'));
    tot.appendChild(row('Total Suite Investment', fmt(print+fee)+' <span class="dc-sum-cur">AUD</span>', 'dc-sum-grand'));
    tot.appendChild(row('Design Fee due today', fmt(fee)+' <span class="dc-sum-cur">AUD</span>', 'dc-sum-due'));
    tot.appendChild(row('Remaining Production Balance', fmt(print)+' <span class="dc-sum-cur">AUD</span> <span class="dc-sum-when">(due on final print approval)</span>', 'dc-sum-remain'));
    r.appendChild(tot);
    r.appendChild(mk('p','dc-sum-note','Your production balance is finalised and charged only after you approve your designs during proofing.'));

    const accBtn = mk('button','dc-sum-toggle','<span class="dc-sum-chev" aria-hidden="true">›</span> Review Itemised Selection Detail'); accBtn.type='button';
    const detail = mk('div','dc-sum-detail'); detail.hidden = true;
    detail.appendChild(mk('div','rev-l','<span class="rl">Design · '+tierLabel+' ('+scopeShort+')</span><span class="rp">'+fmt(fee)+'</span>'));
    ls.forEach(([l,p,st])=>{ if(st===1||st===5) return; detail.appendChild(mk('div','rev-l','<span class="rl">'+l+' <button class="ed" data-goto="'+st+'">edit</button></span><span class="rp">'+fmt(p)+'</span>')); });
    detail.appendChild(mk('div','rev-l','<span class="rl" style="color:#6b6966;font-style:italic">Total estimated production</span><span class="rp" style="color:#6b6966">'+fmt(print)+'</span>'));
    accBtn.addEventListener('click', ()=>{ detail.hidden=!detail.hidden; accBtn.classList.toggle('open', !detail.hidden); });
    r.appendChild(accBtn); r.appendChild(detail);

    // add-ons: Save the Date design comes with the invitation design; on-the-day design is a separate paid add-on (upgrades scope to Full suite)
    const ad = mk('div','dc-addons');
    ad.appendChild(mk('p','dc-addon-h','Complete your suite &amp; save'));
    ad.appendChild(mk('div','dc-included','<span class="dc-included-tick">✓</span><span class="dc-addon-txt"><span class="dc-addon-name">Matching Save the Date design</span><span class="dc-addon-sub">Included with your invitations. One cohesive suite.</span></span>'));
    const on = state.checks.otdDesign;
    const otdLab = mk('label','dc-addon'+(on?' on':''), '<input type="checkbox"'+(on?' checked':'')+'><span class="dc-addon-txt"><span class="dc-addon-name">Add matching on-the-day stationery design</span><span class="dc-addon-sub">Signage, menus, place cards and more, designed to match your suite.</span></span><span class="dc-addon-pr">Design from '+fmt0(P[tier].full)+'</span>');
    otdLab.querySelector('input').addEventListener('change', e=>{ state.checks.otdDesign = e.target.checked; recalc(); validate(); });
    ad.appendChild(otdLab);
    r.appendChild(ad);

    // Canonical 4-step journey; step 1 is already done (the customer just configured).
    const rounds = tier==='TT' ? 'Four rounds for Tailored Touch' : 'Two rounds for Studio Collection';
    const journey = mk('div','dc-journey');
    journey.appendChild(mk('p','dc-journey-h','Your design journey'));
    [['Choose your starting point','Done. Your suite is configured below, and you can adjust it any time before print.', true],
     ['Secure your spot','Your Design Fee begins your design and reserves your place in production. An onboarding email follows, where you can book a Zoom with your designer.'],
     ['Design &amp; refine','Share your details. We create your concept and refine it with you over digital proofs. '+rounds+'. Adjust quantities or finishes anytime.'],
     ['Approve, confirm &amp; we deliver','Nothing prints without your written approval. We print, hand-finish in Perth, and ship Australia-wide, tracked. Your production balance is charged only when you sign off.']]
      .forEach((s,i)=> journey.appendChild(mk('div','dc-journey-step'+(s[2]?' dc-journey-done':''),'<span class="dc-journey-num">'+(s[2]?'✓':(i+1))+'</span><span class="dc-journey-txt"><span class="dc-journey-t">Step '+(i+1)+': '+s[0]+'</span><span class="dc-journey-b">'+s[1]+'</span></span>')));
    r.appendChild(journey);

    // Money line + the second conversion door, right above the pay bar.
    r.appendChild(mk('p','dc-fee-line','Your Design Fee begins your design, reserves your spot in our studio, and goes toward your final total.'));
    r.appendChild(mk('p','dc-discovery','Not sure yet? <a href="/pages/wedding-stationery-consultation">Book a discovery call.</a>'));

    r.querySelectorAll('button.ed[data-goto]').forEach(b=>b.addEventListener('click', ()=>goTo(+b.dataset.goto)));
  }

  // ── Scroll helper ────────────────────────────────────────────────────────
  function scrollToNext(el){
    if(!el) return;
    setTimeout(()=>{
      const prog = document.querySelector('.studio-calc .prog');
      const progH = prog && getComputedStyle(prog).position === 'sticky'
        ? prog.getBoundingClientRect().height : 0;
      const themeHeader = document.querySelector('header[is="sticky-header"], sticky-header, custom-header, .site-header.is-sticky, .header.is-sticky');
      const themeH = themeHeader ? themeHeader.getBoundingClientRect().height : 0;
      const off = progH + themeH + 20;
      const target = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - off);
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        try { window.lenis.scrollTo(target, { duration: 0.6 }); return; } catch(_){}
      }
      try { window.scrollTo({top: target, behavior:'smooth'}); }
      catch(_){ window.scrollTo(0, target); }
    }, 160);
  }
  function pressFin(){ return !$('finLp').hidden ? $('finLp') : (!$('finHf').hidden ? $('finHf') : $('finEm')); }

  // Scroll the calc to viewport top. Multiple fallbacks because Concept theme
  // uses lenis smooth-scroll which intercepts native scroll calls. Order:
  // 1) lenis API if exposed on window, 2) scrollIntoView, 3) explicit retry.
  function scrollToCalcTop(el){
    if (!el) return;
    const computeTarget = () => el.getBoundingClientRect().top + window.pageYOffset;
    const doScroll = () => {
      const target = computeTarget();
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        try { window.lenis.scrollTo(target, { duration: 0.6, force: true }); } catch(_){}
      }
      try { window.scrollTo({ top: target, behavior: 'smooth' }); } catch(_){}
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(_){}
    };
    doScroll();
    // Multi-attempt: re-measure and re-scroll after layout / lenis interactions
    [120, 400, 800].forEach(d => setTimeout(() => {
      const stillOff = Math.abs(el.getBoundingClientRect().top) > 40;
      if (stillOff) doScroll();
    }, d));
  }
  function imgFail(img){ img.style.display='none'; const p=img.parentNode; if(p) p.classList.add('noimg'); }

  // ── Phone (optional contact, Review step) ────────────────────────────────
  function phoneEl(){ return document.getElementById('scalc-phone'); }

  // ── Validation + step navigation ─────────────────────────────────────────
  function paneValid(n){
    switch(n){
      case 1: return state.qty>0;
      case 2: return !!state.style && !!state.size
                  && (state.style==='acrylic' || !!state.format)
                  && (state.style!=='presswork' || !!state.method)
                  && state.qty>=minQty();
      default: return true;
    }
  }
  function validate(){
    const last = state.step===STEPS.length;
    $('nextBtn').disabled = !paneValid(state.step);
    $('nextBtn').textContent = last ? 'Pay Design Fee & start design' : 'Continue';
    // Burgundy CTA state on review step.
    $('nextBtn').classList.toggle('scalc-deposit-cta', last);
    // Inline Continue on step 1 turns solid red once a quantity is entered.
    const s1 = document.querySelector('.dc-step1-next'); if(s1) s1.classList.toggle('is-ready', paneValid(1));
  }
  function renderStep(){
    document.querySelectorAll('.studio-calc .scalc-pane').forEach(p=>p.classList.toggle('active', +p.dataset.step===state.step));
    $('stepNum').textContent = ROMAN[state.step-1];
    $('stepName').textContent = STEPS[state.step-1];
    $('progFill').style.width = (state.step/STEPS.length*100)+'%';
    $('backBtn').disabled = state.step===1;
    // Scroll the calc into view only on step changes (Continue/Back), not on
    // initial page load - the customer should see the product gallery, copy,
    // and other-work content first and scroll down naturally. requestAnimationFrame
    // so layout has settled from the pane-active class toggle before we measure.
    if (!firstRender) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const calcEl = document.querySelector('.studio-calc');
          if (calcEl) scrollToCalcTop(calcEl);
        });
      });
    }
    firstRender = false;
    validate(); recalc();
    if(state.step===1) setTimeout(()=>$('qtyIn').focus({preventScroll:true}), 350);
  }
  function go(dir){
    if(dir>0 && state.step===STEPS.length){ addToCart(); return; }
    if(dir>0 && !paneValid(state.step)) return;
    state.step = Math.min(STEPS.length, Math.max(1, state.step+dir));
    renderStep();
  }
  function goTo(n){ state.step = n; renderStep(); }

  // ── Selectors ────────────────────────────────────────────────────────────
  function setStyle(s){
    if(state.format==='folded' && s!=='digital') return;
    const btn = document.querySelector(`[data-style="${s}"]`);
    if(btn && btn.disabled) return;
    state.style = s;
    if(s==='acrylic'){ state.format = null; document.querySelectorAll('[data-format]').forEach(b=>b.classList.remove('on')); }
    if(s!=='presswork') state.method = null;
    document.querySelectorAll('[data-style]').forEach(b=>b.classList.toggle('on', b.dataset.style===s));
    document.querySelectorAll('[data-method]').forEach(b=>b.classList.remove('on'));
    // Reset finishing groups that no longer apply.
    if(s==='digital') clearFinChecks(['digital']);
    else if(s==='presswork') clearFinChecks([]);  // method selection will set the right group
    else if(s==='acrylic') clearFinChecks(['acrylic']);
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext(state.style==='presswork' ? $('methodGroup') : $('sizeGroup'));
  }
  function setSize(s){
    state.size = s;
    document.querySelectorAll('[data-size]').forEach(b=>b.classList.toggle('on', b.dataset.size===s));
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext(state.style==='acrylic' ? $('finAcrylic') : $('formatGroup'));
  }
  function setFormat(f){
    state.format = f;
    document.querySelectorAll('[data-format]').forEach(b=>b.classList.toggle('on', b.dataset.format===f));
    if(f==='folded'){
      state.style = 'digital';
      state.method = null;
      clearFinChecks(['folded']);
    } else {
      // Switching away from folded: clear folded-only checks; keep digital group.
      clearFinChecks(['digital']);
    }
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext(f==='folded' ? $('finFolded') : (state.style==='presswork' ? pressFin() : $('finDigital')));
  }
  function setMethod(m){
    state.method = m;
    document.querySelectorAll('[data-method]').forEach(b=>b.classList.toggle('on', b.dataset.method===m));
    // Keep only this method's finishing group.
    clearFinChecks([m]);
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext($('sizeGroup'));
  }
  function chk(k,on){ state.checks[k] = !!on; recalc(); }
  function updateSetShapeLabels(){
    const folded = state.format==='folded';
    if(folded && state.info>1){ state.info = 1; const ss = $('setSel'); if(ss) ss.value = 1; }
    const o1 = $('setOpt1'); if(o1) o1.textContent = folded ? 'Invite + additional card + envelopes' : 'Invite + 1 info card + envelopes';
    const o2set = $('setOpt2'); if(o2set) o2set.hidden = folded;
    const o2 = $('shapeOpt2');
    if(o2){ o2.hidden = state.info<1; o2.textContent = folded ? 'Shape the additional card' : (state.info===2 ? 'Shape info card 1' : 'Shape the info card'); }
    const shapeSel = $('shapeSel'); if(shapeSel){
      const o3 = shapeSel.querySelector('option[value="3"]'); if(o3) o3.hidden = !(state.info===2 && !folded);
    }
  }
  function setInfo(n){
    state.info = n;
    if(state.shape===3 && n!==2){ state.shape = 0; $('shapeSel').value = 0; }
    if(state.shape===2 && n<1){ state.shape = 0; $('shapeSel').value = 0; }
    const folded = state.format==='folded';
    $('setHint').textContent = n===0
      ? 'Just the invitation and envelopes. Clean and classic.'
      : (folded
          ? 'An additional card for your digital RSVP, wishing well and website QR code.'
          : 'One card covers your digital RSVP, wishing well and website QR code. Add a second for travel or accommodation details.');
    updateSetShapeLabels();
    recalc();
  }
  function setShape(n){ state.shape = n; recalc(); }
  function setPocketFoil(v){ state.pocketFoil = v; document.querySelectorAll('[data-pf]').forEach(b=>b.classList.toggle('on', b.dataset.pf===v)); recalc(); }
  function setRibbon(v){ state.ribbon = v; document.querySelectorAll('[data-rb]').forEach(b=>b.classList.toggle('on', b.dataset.rb===v)); recalc(); }
  function setSeal(v){
    state.seal = v;
    document.querySelectorAll('[data-seal]').forEach(b=>{ const on = b.dataset.seal===v; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    const sub = $('waxType'); if(sub) sub.hidden = v!=='wax';
    recalc();
  }
  function setWax(v){ state.waxType = v; document.querySelectorAll('[data-wt]').forEach(b=>b.classList.toggle('on', b.dataset.wt===v)); recalc(); }
  function setPay(m){ state.pay = m; document.querySelectorAll('[data-pay]').forEach(b=>b.classList.toggle('on', b.dataset.pay===m)); recalc(); validate(); }
  function togTile(key){
    state.checks[key] = !state.checks[key];
    const el = document.querySelector(`[data-tile="${key}"]`);
    if(el){ el.classList.toggle('on', state.checks[key]); el.setAttribute('aria-pressed', state.checks[key]); }
    if(key==='pockets'){ const sub = $('pocketFoil'); if(sub) sub.hidden = !state.checks[key]; }
    if(key==='ribbon'){  const sub = $('ribbonType'); if(sub) sub.hidden = !state.checks[key]; }
    recalc();
  }

  // ── Add to cart (mirrors product-zurich-calc.js addToCart) ───────────────
  function gidToNumeric(gid){ if(!gid) return null; const m = String(gid).match(/(\d+)$/); return m ? m[1] : null; }
  function prettySize(s){ return {'100x150':'Petite (100×150)','120x180':'Standard (120×180)','148x210':'Traditional (148×210)'}[s] || s || '–'; }
  function prettyFormat(f){ if(!f) return '–'; return {flat:'Flat', folded:'Folded'}[f] || f; }
  function prettyPrint(s){
    if(s.style==='acrylic') return 'Acrylic';
    if(s.format==='folded') return 'Folded · Fine Digital';
    if(s.style==='digital') return 'Fine Digital';
    if(s.style==='presswork') return ({letterpress:'Letterpress', hotfoil:'Hot Foil', embossed:'Embossing'}[s.method]) || 'Luxury Presswork';
    return '–';
  }
  function prettyShape(n){ return {0:'None', 1:'Invitation only', 2:'Info card only', 3:'Both info cards', 4:'Full set'}[n] || 'None'; }
  function capitalize(str){ return str ? str[0].toUpperCase()+str.slice(1) : ''; }
  function prettyAddOns(cc, s){
    const labels = {
      dsp:'Double-sided', foilS:'Foil front', duplex:'Duplexing',
      lp2pms:'Letterpress 2-PMS', lpFoil:'LP + Hot foil',
      hfDigital:'HF + Digital', hfLp:'HF + Letterpress',
      emLp:'Embossed + LP', emHf:'Embossed + Foil',
      foldFoilS:'Folded foil front', foldFoilD:'Folded foil both',
      acMirror:'Mirror acrylic', acNames:'Acrylic guest names',
      guestNames:'Guest name printing (free)',
      clips:'Paper clips', band:'Belly band', vellum:'Vellum wrap',
      illust:'Hand-drawn illustration',
      monogram:'Custom monogram',
      envUp:'Premium envelope', envAddr:'Guest addressing', envLiner:'Envelope liner', envEmb:'Envelope embossing',
      magnets:'Magnets (free)', stampDesign:'MyStamps design (free)',
      digitalInv:'Digital invitation (free)',
      stdDesign:'Matching save-the-date design (included)',
      assembly:'Assembly',
      otdDesign:'On-the-day design ($100)'
    };
    return Object.keys(cc).filter(k=>cc[k] && labels[k]).map(k=>labels[k]).join(', ');
  }

  async function addToCart(){
    const btn = document.querySelector('.dc-cta') || $('nextBtn');
    if(!state.qty || (!state.style && state.format!=='folded')){ showError('Please complete your invitation selections.'); return; }
    if(!window.FelDesign){ showError('Sorry, the order helper did not load. Please refresh and try again.'); return; }

    const originalText = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }

    const prioChk = $('prioChk');
    // The $0 Print Configuration line carries every print/suite spec for later invoicing.
    const printProps = {
      'Product': cfg.tier==='TT' ? 'Invitations (Tailored Touch)' : 'Invitations (Studio Collection)',
      '_edit_url': (typeof location !== 'undefined' ? location.pathname : ''),
      'Quantity': String(state.qty),
      'Size': prettySize(state.size),
      'Format': prettyFormat(state.format),
      'Print method': prettyPrint(state),
      'Info cards': String(state.info),
      'Cut to shape': prettyShape(state.shape),
      'Ribbon': state.checks.ribbon ? capitalize(state.ribbon) : 'None',
      'Pockets': state.checks.pockets ? ('Yes · ' + (state.pocketFoil==='foil' ? 'signature foil' : 'digital print')) : 'No',
      'Seal': state.seal==='wax'
        ? ('Custom wax · ' + (state.waxType==='adhesive' ? 'adhesive' : 'sticks'))
        : 'Sticker (complimentary)',
      'Stamp design (free)':       state.checks.stampDesign  ? 'Yes' : 'No',
      'Magnets (free)':            state.checks.magnets      ? 'Yes' : 'No',
      'Digital invitation (free)': state.checks.digitalInv   ? 'Yes' : 'No',
      'Guest name printing (free)':state.checks.guestNames   ? 'Yes' : 'No',
      'White Glove Assembly':      state.checks.assembly     ? 'Yes' : 'No',
      'Keepsake set (free)':       'Included',
      'Priority Studio Service':   (prioChk && prioChk.checked) ? 'Quote requested' : 'No',
      'Add-ons': prettyAddOns(state.checks, state),
      'Estimated production balance (AUD)': fmt(printTotal()),
      // Hidden from the customer cart (key starts with "_") but visible to the
      // merchant on the order in Shopify Admin - full itemised print breakdown.
      '_print breakdown': lines().filter(([,,st])=> st!==1 && st!==5).map(([l,p])=>`${l}: ${fmt(p)}`).join(' | ')
    };
    const SCALC_HIDE = new Set(['No', 'None', '0', '']);
    Object.keys(printProps).forEach(k => { if (!printProps[k] || SCALC_HIDE.has(printProps[k])) delete printProps[k]; });

    const designProps = {
      'Booked from': cfg.tier==='TT' ? 'Tailored Touch invitations page' : 'Studio Collection invitations page',
      'Invitation quantity': String(state.qty),
      'Matching Save the Date design': 'Included with your invitations'
    };
    // Record WHICH Studio Collection design (suite) the customer configured, so it shows
    // on the cart line. Hidden key (leading "_") → the cart template renders it in bold
    // right next to "Studio Collection". Only when it's a specific suite (not the generic
    // Studio Collection landing page or the bespoke Tailored Touch tier).
    if (cfg.tier === 'SC' && cfg.productTitle) {
      const t = cfg.productTitle.toLowerCase();
      if (t !== 'studio collection' && t !== (cfg.designName||'').toLowerCase()) {
        designProps['_suite'] = cfg.productTitle;
      }
    }

    try {
      // Reconcile the scope-tiered design fee across the cart (charged once) and add
      // this product's $0 print line; the helper redirects to /cart on success.
      await window.FelDesign.checkout({
        tier: designTierKey(),
        scope: designScopeKey(),
        printKey: cfg.tier==='TT' ? 'inv-tt' : 'inv-studio',
        printProps: printProps,
        designProps: designProps,
        redirect: true
      });
    } catch(err){
      console.error('[SCalc.addToCart]', err);
      showError('Sorry, something went wrong: ' + (err.message || 'unknown') + ' - email info@felicitations.com.au');
      if(btn){ btn.disabled = false; btn.textContent = originalText; }
    }
  }

  // Measure the theme's sticky header height and expose it as a CSS variable
  // so the prog bar sticks BELOW it instead of overlapping the logo / menu.
  function updateHeaderOffset(){
    const headerEl = document.querySelector('header[is="sticky-header"], sticky-header, custom-header, .site-header, .header__wrapper, .shopify-section-header');
    const computed = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--scalc-header-offset', computed + 'px');
  }

  // Hide the floating bar when the calculator is fully scrolled out of view.
  function setupBarVisibility(){
    const calc = document.querySelector('.studio-calc');
    const bar  = document.querySelector('.studio-calc-bar');
    if(!calc || !bar) return;
    if(!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries)=>{
      bar.classList.toggle('scalc-hidden', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(calc);
  }

  // Hide the inline hero/intro CTAs ("Secure your spot" / "Secure your deposit"
  // and any "check your investment" copy) on product pages that have the
  // calculator. The customer should USE the calculator instead of bouncing to
  // a separate quote page. The FLOATING theme bar (<product-sticky-form>)
  // stays - it's hidden while the calc is in view and reappears once the
  // customer scrolls past the print & finishes section.
  function hideInlineCTAs(){
    const calc = document.querySelector('.studio-calc');
    if (!calc) return;

    const isInsideFloatingBar = el => !!el.closest('product-sticky-form, .product-sticky-form, .product-sticky-form__card');

    // 1. Hide "Secure your spot / your deposit" buttons NOT inside the floating bar.
    document.querySelectorAll('a, button').forEach(el => {
      const text = (el.textContent || '').trim().toLowerCase();
      if (!text) return;
      if (text === 'secure your spot' || text === 'secure your deposit' ||
          text.startsWith('secure your spot') || text.startsWith('secure your deposit')) {
        if (isInsideFloatingBar(el)) return;
        el.style.setProperty('display', 'none', 'important');
      }
    });

    // 2. Hide "Check your investment" intro copy / link / button.
    document.querySelectorAll('a, p, span, div, button, h1, h2, h3, h4, h5, h6').forEach(el => {
      if (isInsideFloatingBar(el)) return;
      // Don't accidentally hide our own calc content.
      if (el.closest('.studio-calc')) return;
      const txt = (el.textContent || '').trim().toLowerCase();
      if (!txt || txt.length > 80) return;
      if (txt.includes('check your investment') || txt.includes('see your investment') || txt.includes('your investment estimate')) {
        el.style.setProperty('display', 'none', 'important');
        // Hide the immediate wrapper if it only existed for this snippet.
        const p = el.parentElement;
        if (p && p.children.length <= 2) p.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Hide the THEME'S floating product-sticky-form while the calculator is in
  // the viewport so the two floating bars don't fight for the same space.
  // The theme bar reappears once the customer has scrolled past the calc
  // (which usually means past the print & finishes / materials section).
  function setupThemeStickyHide(){
    const calc = document.querySelector('.studio-calc');
    if (!calc) return;
    if (!('IntersectionObserver' in window)) return;
    // Theme's bar is <product-sticky-form> with class .product-sticky-form.
    // Re-query each fire because the theme can lazy-attach it.
    const obs = new IntersectionObserver((entries) => {
      const calcInView = entries[0].isIntersecting;
      document.querySelectorAll('product-sticky-form, .product-sticky-form').forEach(bar => {
        if (calcInView) {
          bar.dataset.scalcHidPrev = bar.style.display || '';
          bar.style.setProperty('display', 'none', 'important');
        } else if (bar.dataset.scalcHidPrev !== undefined) {
          bar.style.display = bar.dataset.scalcHidPrev;
          delete bar.dataset.scalcHidPrev;
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(calc);
  }
  function showError(msg){
    let el = $('scalc-err');
    if(!el){
      el = document.createElement('p');
      el.id = 'scalc-err';
      el.className = 'err';
      const rev = $('rev'); if(rev && rev.parentNode) rev.parentNode.appendChild(el);
    }
    el.textContent = msg;
  }

  // ── Tile rendering ───────────────────────────────────────────────────────
  function tileHTML(key, name){
    return `<button type="button" class="scalc-tile" data-tile="${key}" data-tile-action="toggle" aria-pressed="false">
      <div class="img"><img src="${ICON[key]||''}" alt="${name}" data-img-onerror="1"></div>
      <div class="nm">${name}</div>
      <div class="pr"><span data-tileprice="${key}"></span></div>
    </button>`;
  }
  function buildTiles(){
    $('accTiles').innerHTML =
      tileHTML('clips','Paper Clips') +
      tileHTML('ribbon','Hand-Tied Ribbon') +
      `<div class="scalc-sub-opts brk" id="ribbonType" hidden>
         <button type="button" class="scalc-opt on" data-rb="satin">Satin +$7</button>
         <button type="button" class="scalc-opt" data-rb="velvet">Velvet +$9</button>
         <button type="button" class="scalc-opt" data-rb="silk">Silk +$12</button>
       </div>` +
      tileHTML('band','Band') +
      tileHTML('vellum','Vellum Wrap') +
      tileHTML('pockets','Custom Pockets') +
      `<div class="scalc-sub-opts brk" id="pocketFoil" hidden>
         <button type="button" class="scalc-opt on" data-pf="digital">Digital print</button>
         <button type="button" class="scalc-opt" data-pf="foil">Signature Foil +$8</button>
       </div>`;
    $('hiddenTiles').innerHTML =
      `<button type="button" class="scalc-tile" data-tile="envLiner" data-tile-action="toggle" aria-pressed="false">
         <div class="img"><img src="${ICON.liner}" alt="Envelope Liner" data-img-onerror="1"></div>
         <div class="nm">Envelope Liner</div>
         <div class="pr"><span data-tileprice="liner"></span></div>
       </button>
       <button type="button" class="scalc-tile" data-tile="envEmb" data-tile-action="toggle" aria-pressed="false">
         <div class="img"><img src="${ICON.emboss}" alt="Envelope Embossing" data-img-onerror="1"></div>
         <div class="nm">Envelope Embossing</div>
         <div class="pr"><span data-tileprice="emboss"></span></div>
       </button>`;
    // HTML order: Sticker, Wax, sub-opts, Stamp Design.
    // On mobile/tablet (1-2 tiles per row) this puts the wax sub-options right
    // under the Wax tile - natural parent/child relationship.
    // On desktop (3 tiles per row) CSS sets order:99 on #waxType so the
    // sub-options visually move AFTER Stamp Design and Stamp Design stays in
    // the same row as Sticker + Wax.
    $('sealTiles').innerHTML =
      `<button type="button" class="scalc-tile on" data-seal="sticker" aria-pressed="true">
         <div class="img"><img src="${ICON.sticker}" alt="Sticker Seal" data-img-onerror="1"></div>
         <div class="nm">Sticker Seal</div>
         <div class="pr" style="color:#7a1c1a">Included free</div>
       </button>` +
      `<button type="button" class="scalc-tile" data-seal="wax" aria-pressed="false">
         <div class="img"><img src="${ICON.wax}" alt="Custom Wax Seal" data-img-onerror="1"></div>
         <div class="nm">Custom Wax Seal</div>
         <div class="pr">$195 + per piece</div>
       </button>` +
      `<div class="scalc-sub-opts brk" id="waxType" hidden>
         <button type="button" class="scalc-opt on" data-wt="adhesive">Adhesive +$5.50/ea</button>
         <button type="button" class="scalc-opt" data-wt="stick">DIY sticks +$9.50</button>
       </div>` +
      `<button type="button" class="scalc-tile" data-tile="stampDesign" data-tile-action="toggle" aria-pressed="false">
         <div class="img"><img src="${ICON.stamp}" alt="Stamp Design" data-img-onerror="1"></div>
         <div class="nm">Stamp Design</div>
         <div class="pr" style="color:#7a1c1a">Optional · free</div>
       </button>`;
  }

  // ── Event wiring (no inline onclicks; everything is delegated) ───────────
  // ── Process info popup ────────────────────────────────────────────────────
  // Tailored Touch gets a longer process (5 business days / 4 revision rounds);
  // Studio Collection suites are 3 days / 2 rounds. Tier is fixed per product
  // here (this calc serves SC suites + the TT product), read from the design name.
  function updateInfoPopup(){
    const isTT = (cfg.designName || '').toLowerCase().indexOf('tailored') > -1;
    const d = document.querySelector('.scalc-info-days');   if(d) d.textContent = isTT ? 'five' : 'three';
    const r = document.querySelector('.scalc-info-rounds'); if(r) r.textContent = isTT ? 'four' : 'two';
  }
  function openInfo(){ updateInfoPopup(); const m = $('scalcInfo'); if(m){ m.hidden = false; try{ document.documentElement.style.overflow='hidden'; }catch(e){} } }
  function closeInfo(){ const m = $('scalcInfo'); if(m){ m.hidden = true; try{ document.documentElement.style.overflow=''; }catch(e){} } }

  function wireEvents(root){
    // Image error fallback (replaces inline onerror).
    root.addEventListener('error', (e)=>{
      const t = e.target;
      if(t && t.tagName === 'IMG' && t.dataset.imgOnerror) imgFail(t);
    }, true);

    // Click delegation.
    root.addEventListener('click', (e)=>{
      const t = e.target.closest('[data-action], [data-style], [data-method], [data-size], [data-format], [data-tile-action], [data-seal], [data-rb], [data-pf], [data-wt], [data-pay], .scalc-chip, .scalc-stepper, .scalc-skip');
      if(!t) return;
      const ds = t.dataset;
      if(ds.action === 'go'){ go(parseInt(ds.dir,10)); return; }
      if(ds.action === 'bump'){ bump(parseInt(ds.amt,10)); return; }
      if(ds.action === 'infoOpen'){ openInfo(); return; }
      if(ds.action === 'infoClose'){ closeInfo(); return; }
      if(t.classList.contains('scalc-chip')){ pick(+ds.q); return; }
      if(t.classList.contains('scalc-skip')){ go(1); return; }
      if(ds.style){  setStyle(ds.style);   return; }
      if(ds.method){ setMethod(ds.method); return; }
      if(ds.size){   setSize(ds.size);     return; }
      if(ds.format){ setFormat(ds.format); return; }
      if(ds.tileAction === 'toggle'){ togTile(ds.tile); return; }
      if(ds.seal){ setSeal(ds.seal); return; }
      if(ds.rb){   setRibbon(ds.rb);    return; }
      if(ds.pf){   setPocketFoil(ds.pf); return; }
      if(ds.wt){   setWax(ds.wt);       return; }
      if(ds.pay){  setPay(ds.pay); addToCart(); return; }
    });

    // Checkbox + input + select delegation.
    root.addEventListener('change', (e)=>{
      const t = e.target;
      if(t.matches('[data-c]')){ chk(t.dataset.c, t.checked); return; }
      if(t.id === 'setSel'){    setInfo(+t.value); return; }
      if(t.id === 'shapeSel'){  setShape(+t.value); return; }
      if(t.id === 'addrSel'){   chk('envAddr', +t.value===1); return; }
    });
    root.addEventListener('input', (e)=>{
      if(e.target.id === 'qtyIn') onQty(e.target.value);
    });
    document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') closeInfo(); });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function readCfg(rootEl){
    const d = rootEl.dataset;
    cfg.designBase = parseFloat(d.designBase) || 200;
    cfg.deposit    = parseFloat(d.depositAmount) || 200;
    cfg.depositVariantGid = d.depositVariantId || '';
    cfg.fullVariantGid    = d.fullVariantId    || '';
    cfg.otdVariantGid     = d.otdVariantId     || '';
    cfg.otdAmount  = parseFloat(d.otdAmount) || 100;
    { const mv = parseFloat(d.monogramAmount); cfg.monogramAmount = isNaN(mv) ? 50 : mv; } // 0 = included (TT)
    cfg.designName = d.designName || 'Studio Collection';
    cfg.productTitle = (d.productTitle || '').trim(); // the specific suite the customer configured (e.g. "The Positano Suite")
    cfg.tier = (d.designTier === 'TT') ? 'TT' : 'SC'; // Tailored Touch page sets data-design-tier="TT"
    // Reflect the Design Fee amount in the legacy pay button label (if present).
    const depBtn = document.querySelector('[data-pay="deposit"]');
    if(depBtn && depBtn.firstChild) depBtn.firstChild.nodeValue = `Pay Design Fee · $${cfg.deposit}`;
  }

  function init(){
    const root = document.querySelector('.studio-calc');
    if(!root) return;

    // Initial page load (navigating in from a collection page or anywhere
    // else): force the viewport to the top so the customer lands on the hero
    // gallery and intro - NOT auto-scrolled into the calculator.
    // We disable native scroll restoration, clear any anchor in the URL,
    // and call scrollTo() with multiple fallbacks and retries because the
    // theme's lenis smooth-scroll library can intercept native scroll.
    if (firstRender) {
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(_){}
      try {
        const navType = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]?.type)
          || (performance.navigation && performance.navigation.type === 0 ? 'navigate' : 'other');
        if (navType === 'navigate' || navType === 'reload') {
          if (location.hash && /studio|calc|scalc/i.test(location.hash)) {
            history.replaceState(null, '', location.pathname + location.search);
          }
          const forceTop = () => {
            try { window.lenis && window.lenis.scrollTo && window.lenis.scrollTo(0, { immediate: true, force: true, lock: true }); } catch(_){}
            try { window.scrollTo(0, 0); } catch(_){}
            try { document.documentElement.scrollTop = 0; } catch(_){}
            try { document.body && (document.body.scrollTop = 0); } catch(_){}
          };
          forceTop();
          [0, 50, 150, 350, 700].forEach(d => setTimeout(forceTop, d));
        }
      } catch(_){}
    }

    readCfg(root);
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset, { passive: true });
    // Chips for the quick-pick quantity row.
    const chips = $('chips');
    if(chips){
      [30,50,80,100,120].forEach(q=>{
        const c = document.createElement('button');
        c.type = 'button';
        c.className = 'scalc-chip';
        c.dataset.q = q;
        c.textContent = q;
        chips.appendChild(c);
      });
    }
    buildTiles();
    wireEvents(root);
    setupBarVisibility();
    hideInlineCTAs();
    setupThemeStickyHide();

    // Restore a previous in-progress quote (localStorage) before first paint, so
    // a returning visitor lands on their selections with a "Welcome back" banner.
    let welcomeTs = null;
    const loaded = scalcLoad();
    if(loaded && loaded.data){
      Object.assign(state, loaded.data);
      if(!state.checks) state.checks = {};
      state.pay = 'deposit';            // "Pay full" was removed
      if(scalcHasMeaningful()){
        scalcApplyRestoredUI();
        welcomeTs = loaded.ts;
      }
    }

    refreshReveal();
    renderStep();
    if(welcomeTs) scalcShowWelcome(welcomeTs);
  }

  // ── DIAGNOSTIC (disabled - kept for future debugging via ?scalc_debug=1) ──
  function startDiagnostic(){
    if (!/[?&]scalc_debug=1\b/.test(location.search)) return;
    if (window.__scalcDiagStarted) return;
    window.__scalcDiagStarted = true;

    const panel = document.createElement('div');
    panel.id = 'scalc-debug';
    panel.style.cssText = 'position:fixed;top:80px;left:10px;width:340px;max-height:60vh;overflow:auto;background:#000;color:#0f0;font-family:monospace;font-size:11px;line-height:1.35;padding:10px;z-index:99999;border:2px solid #0f0;border-radius:4px;white-space:pre-wrap;word-break:break-word;';
    panel.textContent = '[SCalc diagnostic - watching buttons]\n';
    document.body.appendChild(panel);

    const log = (msg, color) => {
      const t = new Date().toISOString().slice(11,19);
      const line = document.createElement('div');
      if(color) line.style.color = color;
      line.textContent = `${t} ${msg}`;
      panel.appendChild(line);
      panel.scrollTop = panel.scrollHeight;
      console.log('[SCalc-diag]', msg);
    };

    const queryButtons = () => document.querySelectorAll('.studio-calc .scalc-btns .scalc-opt');
    const buttons0 = queryButtons();
    log(`init: ${buttons0.length} buttons in .scalc-btns`, '#9f9');

    if (buttons0.length){
      // FORCE bright debug colors on every button so we can SEE them regardless of theme CSS.
      buttons0.forEach(b => {
        b.style.cssText += ';background:#ff0!important;color:#000!important;border:3px solid #f00!important;min-height:60px!important;min-width:120px!important;height:auto!important;padding:8px!important;font-weight:bold!important;';
      });
      buttons0.forEach((b, i) => {
        const s = getComputedStyle(b);
        const r = b.getBoundingClientRect();
        const visible = r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
        log(`btn[${i}] ${b.dataset.style||b.dataset.method||b.dataset.size||b.dataset.format||'?'} | disp=${s.display} vis=${s.visibility} op=${s.opacity}`, '#9f9');
        log(`     rect: x=${r.x.toFixed(0)} y=${r.y.toFixed(0)} w=${r.width.toFixed(0)} h=${r.height.toFixed(0)} | onscreen=${visible}`, visible?'#9f9':'#f55');
        if (i === 0) {
          const p = b.parentElement;
          const pr = p.getBoundingClientRect();
          const ps = getComputedStyle(p);
          log(`parent .scalc-btns: cls="${p.className}" disp=${ps.display} dir=${ps.flexDirection} h=${pr.height.toFixed(0)} y=${pr.y.toFixed(0)}`, '#cf9');
          const pp = p.parentElement;
          const ppr = pp.getBoundingClientRect();
          const pps = getComputedStyle(pp);
          log(`grandparent .scalc-group: cls="${pp.className}" disp=${pps.display} h=${ppr.height.toFixed(0)} hidden=${pp.hasAttribute('hidden')}`, '#cf9');
        }

        const o = new MutationObserver(muts => {
          muts.forEach(m => {
            const stack = (new Error('mut')).stack || '';
            const externalFrame = stack.split('\n').slice(2).find(l => l && !l.includes('product-studio-calc.js'));
            log(`btn[${i}] MUTATED ${m.attributeName} by: ${externalFrame||'?'}`, '#f99');
          });
          // Defense: revert attempts to hide
          b.style.removeProperty('display');
          b.style.removeProperty('visibility');
          b.style.removeProperty('opacity');
          b.removeAttribute('hidden');
        });
        o.observe(b, { attributes: true, attributeFilter: ['style','class','hidden'] });
      });
    }

    // Watch parent containers for child removal
    const wiz = document.querySelector('.studio-calc');
    if (wiz){
      const o = new MutationObserver(muts => {
        muts.forEach(m => {
          m.removedNodes.forEach(n => {
            if(n.nodeType !== 1) return;
            const matches = n.matches?.('.scalc-btns, .scalc-opt') || n.querySelector?.('.scalc-btns, .scalc-opt');
            if(matches){
              const stack = (new Error('removal')).stack || '';
              const externalFrame = stack.split('\n').slice(2).find(l => l && !l.includes('product-studio-calc.js'));
              log(`REMOVED FROM DOM: ${n.className||n.tagName} by: ${externalFrame||'?'}`, '#f55');
            }
          });
        });
      });
      o.observe(wiz, { childList: true, subtree: true });
    }

    // Continuous monitor - re-measures across step changes so we see what
    // happens when the user clicks Continue.
    let tick = 0;
    let lastStep = null;
    const iv = setInterval(() => {
      tick++;
      const panes = document.querySelectorAll('.studio-calc .scalc-pane');
      const active = document.querySelector('.studio-calc .scalc-pane.active');
      const step = active ? active.dataset.step : '?';

      if (step !== lastStep) {
        log(`>>> STEP CHANGE: ${lastStep||'init'} → ${step}`, '#ff0');
        // Dump per-pane display state
        panes.forEach(p => {
          const s = getComputedStyle(p);
          log(`  pane[${p.dataset.step}] active=${p.classList.contains('active')} display=${s.display}`, '#ccf');
        });
        // For new step, log first button + its parents
        if (active) {
          const styleBtns = active.querySelectorAll('[data-style]');
          const allBtns = active.querySelectorAll('.scalc-opt');
          log(`  step ${step}: ${styleBtns.length} data-style btns, ${allBtns.length} scalc-opt total`, '#cf9');
          if (allBtns.length) {
            const b = allBtns[0];
            const r = b.getBoundingClientRect();
            const s = getComputedStyle(b);
            log(`  first btn (${b.dataset.style||b.dataset.method||'?'}): rect w=${r.width.toFixed(0)} h=${r.height.toFixed(0)} x=${r.x.toFixed(0)} y=${r.y.toFixed(0)}`, r.width>0 && r.height>0?'#9f9':'#f55');
            log(`  first btn computed: disp=${s.display} vis=${s.visibility}`, '#cf9');
            const p = b.parentElement;
            const pr = p.getBoundingClientRect();
            const ps = getComputedStyle(p);
            log(`  btn parent .${p.className.split(' ')[0]}: rect w=${pr.width.toFixed(0)} h=${pr.height.toFixed(0)} | disp=${ps.display} hidden=${p.hasAttribute('hidden')}`, pr.height>0?'#cf9':'#f55');
          }
        }
        lastStep = step;
      }

      if (tick >= 40) { // run for ~30s
        clearInterval(iv);
        log('- monitoring stopped -', '#999');
      }
    }, 800);
  }
  // ─────────────────────────────────────────────────────────────────────────

  // Public namespace - kept minimal; UI is event-delegated so we don't need
  // to expose handler functions on window for inline onclick attributes.
  window.SCalc = { go, goTo, bump, pick, addToCart, init };

  function safeInit(){
    try {
      if (document.querySelector('.studio-calc')) init();
    } catch(err){
      console.error('[SCalc] init failed', err);
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeInit);
  else safeInit();

  // Shopify theme editor reloads the section when settings change. Re-run init
  // so events and state are wired to the freshly-rendered DOM.
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('.studio-calc')) safeInit();
  });
})();
